(() => {
  const MAIN_HANDLES = new Set([
    'all-mens-chains', 'gold-chains', 'chain',
    'allbracelets', 'bracelets',
    'pendants-1', 'gold-pendants', 'pendants',
    'all-mens-rings', 'all-gold-rings',
    'all-diamond-products', 'earrings',
    '925-sterling-silver', 'silver'
  ]);

  const EXPLICIT_CHAIN_FILTERS = new Set([
    '10k-gold-chains',
    '14k-gold-chains',
    'white-gold-chains',
    'rose-gold-chains',
    'yellow-gold-chains',
    '10k-all-mens-chains',
    '14k-all-mens-chains'
  ]);

  function currentHandle() {
    const match = window.location.pathname.match(/\/collections\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  }

  function familyFor(handle) {
    if (!handle || MAIN_HANDLES.has(handle)) return null;

    if (EXPLICIT_CHAIN_FILTERS.has(handle) || handle.includes('chain') || handle.includes('necklace')) {
      return { label: 'Gold Chains', url: '/collections/all-mens-chains' };
    }
    if (handle.includes('bracelet')) {
      return { label: 'Bracelets', url: '/collections/allbracelets' };
    }
    if (handle.includes('pendant') || handle.includes('religious') || handle.includes('cross') || handle.includes('jesus') || handle.includes('initial') || handle === 'frames') {
      return { label: 'Pendants', url: '/collections/pendants-1' };
    }
    if (handle.includes('ring')) {
      return { label: 'Rings', url: '/collections/all-mens-rings' };
    }
    if (handle.includes('earring')) {
      return { label: 'Earrings', url: '/collections/earrings' };
    }
    if (handle.includes('diamond')) {
      return { label: 'Diamond Jewelry', url: '/collections/all-diamond-products' };
    }
    if (handle.includes('silver') || handle.includes('925')) {
      return { label: 'Sterling Silver', url: '/collections/925-sterling-silver' };
    }

    return null;
  }

  function injectFallback() {
    const main = document.querySelector("main[data-template^='collection']");
    if (!main || main.querySelector('.fj-collection-return__link')) return;

    const family = familyFor(currentHandle());
    if (!family) return;

    const firstSection = Array.from(main.children).find((node) => node.classList?.contains('shopify-section'));
    if (!firstSection) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'fj-category-navigation-root fj-category-navigation-root--fallback';
    wrapper.innerHTML = `
      <div class="page-width fj-collection-return-shell">
        <nav class="fj-collection-return" aria-label="Collection navigation">
          <a href="${family.url}" class="fj-collection-return__link">
            <span class="fj-collection-return__arrow" aria-hidden="true">←</span>
            <span>Back to ${family.label}</span>
          </a>
        </nav>
      </div>`;

    firstSection.insertAdjacentElement('afterend', wrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectFallback, { once: true });
  } else {
    injectFallback();
  }

  document.addEventListener('shopify:section:load', injectFallback);
})();
